import request from '@/utils/request'
import { getShopId } from '@/api/shop/shopApi'

// 分页查询二维码配置列表
export function listShopQrCodes(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/shopQrCode.queryShopQrCodes',
      method: 'get',
      params: {
        ...params,
        shopId: getShopId()
      }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 新增二维码配置
export function saveShopQrCode(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/shopQrCode.saveShopQrCode',
      method: 'post',
      data: {
        ...data,
        shopId: getShopId()
      }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 修改二维码配置
export function updateShopQrCode(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/shopQrCode.updateShopQrCode',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 删除二维码配置
export function deleteShopQrCode(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/shopQrCode.deleteShopQrCode',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 获取单个二维码配置详情
export function getShopQrCode(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/shopQrCode.getShopQrCode',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 房屋绑定列表
export function listShopQrCodeHouses(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/shopQrCodeHouse.queryShopQrCodeHouses',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 删除房屋绑定
export function deleteShopQrCodeHouse(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/shopQrCodeHouse.deleteShopQrCodeHouse',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 收款记录列表
export function listPayRecords(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/shopQrCodePayRecord.queryPayRecords',
      method: 'get',
      params: {
        ...params,
        shopId: getShopId()
      }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 退款
export function refundPayRecord(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/shopQrCodePayRecord.refundPayRecord',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}
